export const SWITCH_BRAND = "SWITCH_BRAND";

export const requestSwitchBrand = ({ brand_id, brand_name }) => ({
  type: SWITCH_BRAND,
  brand_id,
  brand_name,
});
